// extracted by mini-css-extract-plugin
export default {"labeled-info-container":"styles_labeled-info-container__B4fZw","labeled-info-label":"styles_labeled-info-label__xcTBU","labeled-info-info":"styles_labeled-info-info__RiO1X"};